module.exports = __webpack_public_path__ + "img/DD_rgb.84fa540b.png";